<template>
  <div class="card shadow"
       :class="type === 'dark' ? 'bg-default': ''">
    <div class="card-header border-0"
         :class="type === 'dark' ? 'bg-transparent': ''">
      <div class="row align-items-center">
        <div class="col-md-3">
          <h3 class="mb-0" :class="type === 'dark' ? 'text-white': ''" >
            {{title}} <br><a href="https://docs.justwash.asia/tutorial/deposit" style="color: #007aff; font-size: 14px;   font-weight: 400;" target="_blank">View tutorial</a>
          </h3>
        </div>
        <div class="col-md-7">
          <form role="form">
            <div class="row">
              <div class="col-md-6 ">
                <date-picker style="width:100%" v-model="range" placeholder="เลือกช่วงวันเวลา" range :shortcuts="shortcuts"></date-picker>&nbsp;
              </div>
              <div class="col-md-6">
                <button class="btn btn-primary" type="button" name="button" v-on:click="filter(range)">ค้นหา</button>
              </div>
            </div>
          </form>
        </div>
        <!-- {{range}} -->
        <!-- <date-picker v-model="startRange" name="startDate" placeholder="เลือกช่วงวันเวลา"></date-picker>&nbsp;to&nbsp;
        <date-picker v-model="endRange" name="endDate" placeholder="เลือกช่วงวันเวลา"></date-picker> -->
 <!--        <div class="col-md-2 text-right">
          <base-button type="success" size="sm" @click="tableToExcel('table', 'Lorem Table')">Export</base-button>
        </div> -->
      </div>
    </div>

    <!-- <div class="row">
      <div class="col-md-4">
        col-md-4
      </div>
      <div class="col-md-4">
        col-md-4
      </div>
      <div class="col-md-4">
        col-md-4
      </div>
    </div> -->

    <div class="table-responsive" ref="table" id="loremTable">
      <base-table class="table align-items-center table-flush"
                  :class="type === 'dark' ? 'table-dark': ''"
                  :thead-classes="type === 'dark' ? 'thead-dark': 'thead-light'"
                  tbody-classes="list"
                  :data="tableData">
        <template slot="columns">
          <th class="text-center" style="font-size: 14px;">Deposit From</th>
           <th class="text-center" style="font-size: 14px;">Amount (Bath)</th>


          <!-- <th class="text-center" style="font-size: 14px;">Transection ID</th> -->
          <!-- <th class="text-center" style="font-size: 14px;">Datetime</th> -->
          <th class="text-center" style="font-size: 14px;">From</th>
          <th class="text-center" style="font-size: 14px;">Status</th>

         
          <!-- <th class="text-center" style="font-size: 14px;">Status</th> -->
          <!-- <th></th> -->
        </template>

        <template slot-scope="{row}">
          <!-- <th scope="row">
            <div class="media align-items-center">
              <a href="#" class="avatar rounded-circle mr-3">
                <img alt="Image placeholder" :src="row.img">
              </a>
              <div class="media-body">
                <span class="name mb-0 text-sm">{{row.title}}</span>
              </div>
            </div>
          </th> -->
           <td class="text-center" v-if="row.type == 'PromptPay' || row.type == 'Manual' ">
            <img v-bind:src="SetBankImage(row.payer_bank_code)" width="40px" height="40px"/>
            <!-- {{row.name_desc}}[{{row.name}})] -->
           </td>
           <td class="text-center" v-if="row.type == 'Linepay'">
            <img src="https://justwash.s3-ap-southeast-1.amazonaws.com/bank_logo/linepay.png"  width="40px" height="40px"/>
           </td>
        

          <td class="budget text-center" style="text-align: right;"> 
            <span style="color: green; font-size: 12.5pt; letter-spacing: 1.5px;  ">+{{row.wasing_price_total}} บาท</span>
            <div>{{row.creation}}</div>
            <div style="font-size: 9px; color: #C0C0C0;">({{row.transection_id}})</div>
          </td>



<!--           <td class="text-center">
            {{row.creation}}
          </td> -->
          <td class="text-center">
            <!-- <div class="d-flex align-items-center">
              <span class="completion mr-2">{{row.completion}}%</span>
              <div>
                <base-progress :type="row.statusType"
                               :show-percentage="false"
                               class="pt-0"
                               :value="row.completion"/>
              </div>
            </div> -->
            From : {{row.name_desc}} <br><span style="font-size: 9px; color: #C0C0C0;">[{{row.name}})]</span><br>({{row.type}})
          </td>


          <td class="text-center">
            <span v-if="row.status==='Compleate'" style="color:green">Complete</span>
            <span v-if="row.status==='Pending'" style="color:orange">Pending</span>
            <span v-if="row.status==='Washing'" style="color:blue">In Use</span>

          </td>




          <!-- <td class="text-center">
            <badge class="badge-dot mr-4" :type="row.statusType">
              <i :class="`bg-${row.statusType}`"></i>
              <span class="status">ดำเนินการเสร็จสิ้น{{row.status}}</span>
            </badge>
          </td> -->

          <!-- <td class="text-center">
            <base-dropdown class="dropdown"
                           position="right">
              <a slot="title" class="btn btn-sm btn-primary text-light" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                <i class="fas fa-ellipsis-v"></i>
              </a>

              <template>
                <a class="dropdown-item" href="#">Action</a>
                <a class="dropdown-item" href="#">Another action</a>
                <a class="dropdown-item" href="#">Something else here</a>
              </template>
            </base-dropdown>
          </td> -->

        </template>

      </base-table>


    </div>

<div class="text-center"><div role="alert" class="alert alert-default" style="display: none;"><i class="ni ni-world-2"></i> กำลังโหลดกรุณารอสักครู่...
                            </div></div>

    <div class="card-footer d-flex justify-content-end"
         :class="type === 'dark' ? 'bg-transparent': ''">

    </div>

  </div>
</template>
<script>
  import DatePicker from 'vue2-datepicker';
  import 'vue2-datepicker/index.css';
  import 'vue2-datepicker/locale/th';
  import moment from 'moment';
  import Swal from 'sweetalert2';

  import JwService from '../../service/justwash';
  import apiService from '../../service/api';

  export default {
    components: { DatePicker },
    name: 'deposit-table',
    props: {
      type: {
        type: String
      },
      title: String
    },
    data() {
      return {
        ServiceFee : 0,
        date: '',
        time: '',
        timePickerOptions: {
          start: '00:00',
          step: '00:30',
          end: '23:30'
        },
        datetime: '',
        range: '',
        startRange: '',
        endRange: '',
        shortcuts: [
          {
            text: 'Today',
            onClick: () => {
              this.range = [new Date(), new Date()]
            }
          }
        ],
        uri :'data:application/vnd.ms-excel;base64,',
        template:'<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--></head><body><table>{table}</table></body></html>',
        base64: function(s){ return window.btoa(unescape(encodeURIComponent(s))) },
        format: function(s, c) { return s.replace(/{(\w+)}/g, function(m, p) { return c[p]; }) },
        tableData: null,
        ViewCount : 30,
        bank_code : {
          '001' : {
            'bank_name_thai' : 'ธนาคารแห่งประเทศไทย',
            'bank_name_eng' : 'BANK OF THAILAND',
            'icon' : 'https://justwash.s3-ap-southeast-1.amazonaws.com/bank_logo/non_bank.png'
          },
          '002' : {
            'bank_name_thai' : 'ธนาคารกรุงเทพ จำกัด (มหาชน)',
            'bank_name_eng' : 'BANGKOK BANK PUBLIC COMPANY LTD.',
            'icon' : 'https://justwash.s3-ap-southeast-1.amazonaws.com/bank_logo/bangkok.png'
          },
          '004' : {
            'bank_name_thai' : 'ธนาคารกสิกรไทย จำกัด (มหาชน)',
            'bank_name_eng' : 'KASIKORNBANK PUBLIC COMPANY LIMITED',
            'icon' : 'https://justwash.s3-ap-southeast-1.amazonaws.com/bank_logo/kbank.png'
          },
          '006' : {
            'bank_name_thai' : 'ธนาคารกรุงไทย จำกัด (มหาชน)',
            'bank_name_eng' : 'KRUNG THAI BANK PUBLIC COMPANY LTD.',
            'icon' : 'https://justwash.s3-ap-southeast-1.amazonaws.com/bank_logo/kungthai.png'
          },
          '008' : {
            'bank_name_thai' : 'ธนาคารเจพีมอร์แกน เชส',
            'bank_name_eng' : 'JPMORGAN CHASE BANK, NATIONAL ASSOCIATION',
            'icon' : 'https://justwash.s3-ap-southeast-1.amazonaws.com/bank_logo/non_bank.png'
          },
          '009' : {
            'bank_name_thai' : 'ธนาคารโอเวอร์ซี-ไชนีสแบงกิ้งคอร์ปอเรชั่น จำกัด',
            'bank_name_eng' : 'OVER SEA-CHINESE BANKING CORPORATION LIMITED',
            'icon' : 'https://justwash.s3-ap-southeast-1.amazonaws.com/bank_logo/non_bank.png'
          },
          '011' : {
            'bank_name_thai' : 'ธนาคารทหารไทย จำกัด (มหาชน)',
            'bank_name_eng' : 'TMB BANK PUBLIC COMPANY LIMITED',
            'icon' : 'https://justwash.s3-ap-southeast-1.amazonaws.com/bank_logo/tmb.png'

          },
          '014' : {
            'bank_name_thai' : 'ธนาคารไทยพาณิชย์ จำกัด (มหาชน)',
            'bank_name_eng' : 'SIAM COMMERCIAL BANK PUBLIC COMPANY LTD.',
            'icon' : 'https://justwash.s3-ap-southeast-1.amazonaws.com/bank_logo/scb.png'
          },
          '017' : {
            'bank_name_thai' : 'ธนาคารซิตี้แบงก์ เอ็น.เอ.',
            'bank_name_eng' : 'CITIBANK, N.A.',
            'icon' : 'https://justwash.s3-ap-southeast-1.amazonaws.com/bank_logo/non_bank.png'
          },
          '018' : {
            'bank_name_thai' : 'ธนาคารซูมิโตโม มิตซุย แบงกิ้ง คอร์ปอเรชั่น',
            'bank_name_eng' : 'SUMITOMO MITSUI BANKING CORPORATION',
            'icon' : 'https://justwash.s3-ap-southeast-1.amazonaws.com/bank_logo/non_bank.png'
          },
          '020' : {
            'bank_name_thai' : 'ธนาคารสแตนดาร์ดชาร์เตอร์ด (ไทย) จำกัด (มหาชน)',
            'bank_name_eng' : 'STANDARD CHARTERED BANK (THAI) PUBLIC COMPANY LIMITED',
            'icon' : 'https://justwash.s3-ap-southeast-1.amazonaws.com/bank_logo/non_bank.png'
          },
          '022' : {
            'bank_name_thai' : 'ธนาคารซีไอเอ็มบี ไทย จำกัด (มหาชน)',
            'bank_name_eng' : 'CIMB THAI BANK PUBLIC COMPANY LIMITED',
            'icon' : 'https://justwash.s3-ap-southeast-1.amazonaws.com/bank_logo/cimb.png'
          },
          '023' : {
            'bank_name_thai' : 'ธนาคารอาร์ เอช บี จำกัด',
            'bank_name_eng' : 'RHB BANK BERHAD',
            'icon' : 'https://justwash.s3-ap-southeast-1.amazonaws.com/bank_logo/non_bank.png'
          },
          '024' : {
            'bank_name_thai' : 'ธนาคารยูโอบี จำกัด (มหาชน)',
            'bank_name_eng' : 'UNITED OVERSEAS BANK (THAI) PUBLIC COMPANY LIMITED',
            'icon' : 'https://justwash.s3-ap-southeast-1.amazonaws.com/bank_logo/uob.png'
          },
          '025' : {
            'bank_name_thai' : 'ธนาคารกรุงศรีอยุธยา จำกัด (มหาชน)',
            'bank_name_eng' : 'BANK OF AYUDHYA PUBLIC COMPANY LTD.',
            'icon' : 'https://justwash.s3-ap-southeast-1.amazonaws.com/bank_logo/kungsri.png'
          },
          '026' : {
            'bank_name_thai' :'ธนาคารเมกะ สากลพาณิชย์ จำกัด (มหาชน)',
            'bank_name_eng' : 'MEGA  INTERNATIONAL COMMERCIAL BANK PUBLIC COMPANY LIMITED',
            'icon' : 'https://justwash.s3-ap-southeast-1.amazonaws.com/bank_logo/non_bank.png'
          },

          '027' : {
            'bank_name_thai' :'ธนาคารแห่งอเมริกาเนชั่นแนลแอสโซซิเอชั่น',
            'bank_name_eng' : 'BANK OF AMERICA, NATIONAL ASSOCIATION',
            'icon' : 'https://justwash.s3-ap-southeast-1.amazonaws.com/bank_logo/non_bank.png'
          },
          '029' : {
            'bank_name_thai' :'ธนาคารอินเดียนโอเวอร์ซีส์',
            'bank_name_eng' : 'INDIAN OVERSEA BANK',
            'icon' : 'https://justwash.s3-ap-southeast-1.amazonaws.com/bank_logo/non_bank.png'
          },
          '030' : {
            'bank_name_thai' :'ธนาคารออมสิน',
            'bank_name_eng' : 'GOVERNMENT SAVINGS BANK',
            'icon' : 'https://justwash.s3-ap-southeast-1.amazonaws.com/bank_logo/gsb.png'
          },
          '031' : {
            'bank_name_thai' :'ธนาคารฮ่องกงและเซี่ยงไฮ้แบงกิ้งคอร์ปอเรชั่น จำกัด',
            'bank_name_eng' : 'THE HONGKONG AND SHANGHAI BANKING CORPORATION LTD.',
            'icon' : 'https://justwash.s3-ap-southeast-1.amazonaws.com/bank_logo/non_bank.png'
          },
          '032' : {
            'bank_name_thai' :'ธนาคารดอยซ์แบงก์',
            'bank_name_eng' : 'DEUTSCHE BANK AG.',
            'icon' : 'https://justwash.s3-ap-southeast-1.amazonaws.com/bank_logo/non_bank.png'
          },

          '033' : {
            'bank_name_thai' :'ธนาคารอาคารสงเคราะห์',
            'bank_name_eng' : 'THE GOVERNMENT HOUSING BANK',
            'icon' : 'https://justwash.s3-ap-southeast-1.amazonaws.com/bank_logo/non_bank.png'
          },
          '034' : {
            'bank_name_thai' :'ธนาคารเพื่อการเกษตรและสหกรณ์การเกษตร',
            'bank_name_eng' : 'BANK FOR AGRICULTURE AND AGRICULTURAL COOPERATIVES',
            'icon' : 'https://justwash.s3-ap-southeast-1.amazonaws.com/bank_logo/torgosor.png'
          },
          '035' : {
            'bank_name_thai' :'ธนาคารเพื่อการส่งออกและนำเข้าแห่งประเทศไทย',
            'bank_name_eng' : 'EXPORT-IMPORT BANK OF THAILAND',
            'icon' : 'https://justwash.s3-ap-southeast-1.amazonaws.com/bank_logo/torgosor.png'
          },
          '039' : {
            'bank_name_thai' :'ธนาคารมิซูโฮ จำกัด สาขากรุงเทพฯ',
            'bank_name_eng' : 'MIZUHO BANK, LTD. BANGKOK BRANCH',
            'icon' : 'https://justwash.s3-ap-southeast-1.amazonaws.com/bank_logo/non_bank.png'
          },
          '045' : {
            'bank_name_thai' :'ธนาคารบีเอ็นพี พารีบาส์',
            'bank_name_eng' : 'BNP PARIBAS',
            'icon' : 'https://justwash.s3-ap-southeast-1.amazonaws.com/bank_logo/non_bank.png'
          },
          '052' : {
            'bank_name_thai' :'ธนาคารแห่งประเทศจีน (ไทย) จำกัด (มหาชน)',
            'bank_name_eng' : 'BANK OF CHINA (THAI) PUBLIC COMPANY LIMITED',
            'icon' : 'https://justwash.s3-ap-southeast-1.amazonaws.com/bank_logo/non_bank.png'
          },
          '065' : {
            'bank_name_thai' :'ธนาคารธนชาต จำกัด (มหาชน)',
            'bank_name_eng' : 'THANACHART BANK PUBLIC COMPANY LTD.',
            'icon' : 'https://justwash.s3-ap-southeast-1.amazonaws.com/bank_logo/thanachart.png'
          },
          '066' : {
            'bank_name_thai' :'ธนาคารอิสลามแห่งประเทศไทย',
            'bank_name_eng' : 'ISLAMIC BANK OF THAILAND',
            'icon' : 'https://justwash.s3-ap-southeast-1.amazonaws.com/bank_logo/non_bank.png'
          },

          '067' : {
            'bank_name_thai' :'ธนาคารทิสโก้ จำกัด (มหาชน)',
            'bank_name_eng' : 'TISCO BANK PUBLIC COMPANY LIMITED',
            'icon' : 'https://justwash.s3-ap-southeast-1.amazonaws.com/bank_logo/non_bank.png'
          },
          '069' : {
            'bank_name_thai' :'ธนาคารเกียรตินาคิน จำกัด (มหาชน)',
            'bank_name_eng' : 'KIATNAKIN BANK PUBLIC COMPANY LIMITED',
            'icon' : 'https://justwash.s3-ap-southeast-1.amazonaws.com/bank_logo/non_bank.png'
          },
          '070' : {
            'bank_name_thai' :'ธนาคารไอซีบีซี (ไทย) จำกัด (มหาชน)',
            'bank_name_eng' : 'INDUSTRIAL AND COMMERCIAL BANK OF CHINA (THAI) PUBLIC COMPANY LIMITED',
            'icon' : 'https://justwash.s3-ap-southeast-1.amazonaws.com/bank_logo/non_bank.png'
          },
          '071' : {
            'bank_name_thai' :'ธนาคารไทยเครดิต เพื่อรายย่อย จำกัด (มหาชน)',
            'bank_name_eng' : 'THE THAI CREDIT RETAIL BANK PUBLIC COMPANY LIMITED',
            'icon' : 'https://justwash.s3-ap-southeast-1.amazonaws.com/bank_logo/non_bank.png'
          },
          '073' : {
            'bank_name_thai' :'ธนาคารแลนด์ แอนด์ เฮ้าส์ จำกัด (มหาชน)',
            'bank_name_eng' : 'LAND AND HOUSES BANK PUBLIC COMPANY LIMITED',
            'icon' : 'https://justwash.s3-ap-southeast-1.amazonaws.com/bank_logo/non_bank.png'
          },
          '079' : {
            'bank_name_thai' :'ธนาคารเอเอ็นแซด (ไทย) จำกัด (มหาชน)',
            'bank_name_eng' : 'ANZ BANK (THAI) PUBLIC COMPANY LIMITED',
            'icon' : 'https://justwash.s3-ap-southeast-1.amazonaws.com/bank_logo/non_bank.png'
          },
          '080' : {
            'bank_name_thai' :'ธนาคารซูมิโตโม มิตซุย ทรัสต์ (ไทย) จำกัด (มหาชน)',
            'bank_name_eng' : 'SUMITOMO MITSUI TRUST BANK (THAI) PUBLIC COMPANY LIMITED',
            'icon' : 'https://justwash.s3-ap-southeast-1.amazonaws.com/bank_logo/non_bank.png'
          },
          '099' : {
            'bank_name_thai' :'ไลน์',
            'bank_name_eng' : 'line',
            'icon' : 'https://justwash.s3-ap-southeast-1.amazonaws.com/bank_logo/linepay.png'
          },
          

        },
      }
    },
    methods:{
      tableToExcel(table, name) {
        if (!table.nodeType) table = this.$refs.table
        var ctx = {worksheet: name || 'Worksheet', table: table.innerHTML}
        window.location.href = this.uri + this.base64(this.format(this.template, ctx))
      },
      filter:function(range) {
        this.$isLoading(true)
        this.ViewCount=30
        // console.log(moment(range[0]).format('YYYY-MM-DD')+moment(range[1]).format('YYYY-MM-DD'));
        axios({
          method: 'post',
          url: JwService.getAPI()+'/api/method/justwash.OwnerApi.GetDepositStatements2',
          data: {
            start_date: moment(range[0]).format('YYYY-MM-DD'),
            to_date: moment(range[1]).format('YYYY-MM-DD'),
            limit: 100000000
          },
          headers: {
            'Authorization' : 'Token '+localStorage.getItem('accessToken')
          }
        }).then((response) => {
          // console.log(this.data.start_date);
          // localStorage.setItem('filter', this.data);
          if (response.data.message.status == true) {
            this.$isLoading(false)

            this.tableData = response.data.message.data.statement
            this.ServiceFee = 0
             /* eslint-disable no-console */
            // console.log(this.tableData);
            let summary = 0
            for(var st in  response.data.message.data.statement){
              //console.log(st)
              if(response.data.message.data.statement[st].type=='PromptPay')
                this.ServiceFee+=1;

              summary= summary+response.data.message.data.statement[st].wasing_price_total
            }
            
            this.$emit("UpdateSummary",  {'summary' : summary, 'ServiceFee' : this.ServiceFee})

            // for (let idx in  response.data.message.data) {
            //   console.log(idx)
            // }
            // console.log(this.tableData);
            // console.log(response.data.message.data);
          } else {
            this.$router.push('/login')
          }
        }).catch(error => {
          console.log(error)
          this.$router.push('/login')
        });
      },
      SetBankImage:function(bank_code){
        if(this.bank_code[bank_code] != undefined){
          //console.log(this.bank_code[bank_code].icon)
          //console.log(this.bank_code[bank_code].icon)
          return this.bank_code[bank_code].icon
        }else{
          return 'https://justwash.s3-ap-southeast-1.amazonaws.com/bank_logo/non_bank.png'
        }
        
      },
      ViewTransectionMore: function(range){
        this.$isLoading(true)

        if(range[0]==undefined){
                this.ViewCount+=30
                //No Fileter
                axios({
                  method: 'post',
                  url: JwService.getAPI()+'/api/method/justwash.OwnerApi.GetDepositStatements2',
                  data: {
                    start_date: moment().format('YYYY-MM-DD'),
                    to_date: moment().format('YYYY-MM-DD'),
                    limit: 100000000
                  },
                  headers: {
                    'Authorization' : 'Token '+localStorage.getItem('accessToken')
                  }
                }).then((response) => {
                  if (response.data.message.status==true) {

                    this.$isLoading(false)
                    this.tableData = response.data.message.data.statement
                 /* eslint-disable no-console */
                    //  console.log(this.tableData);
                     
                    //this.$emit("UpdateSummary", response.data.message.data.summary)
                    this.ServiceFee = 0
                    let summary = 0;
                    for(var st in  response.data.message.data.statement){
                      //console.log(st)
                      if(response.data.message.data.statement[st].type=='PromptPay')
                        this.ServiceFee+=1;

                      summary= summary+response.data.message.data.statement[st].wasing_price_total
                    }
                    
                    this.$emit("UpdateSummary",  {'summary' : summary, 'ServiceFee' : this.ServiceFee})

                    // for (let idx in  response.data.message.data) {
                    //   console.log(idx)
                    // }
                    // console.log(this.tableData);
                    // console.log(response.data.message.data);
                  } else {
                    this.$router.push('/login')
                  }
                }).catch(error => {
                  console.log(error)
                  this.$router.push('/login')
                });
        }else{
              this.ViewCount+=30
              //Filter Add
              axios({
                method: 'post',
                url: JwService.getAPI()+'/api/method/justwash.OwnerApi.GetDepositStatements2',
                data: {
                  start_date: moment(range[0]).format('YYYY-MM-DD'),
                  to_date: moment(range[1]).format('YYYY-MM-DD'),
                 limit: 100000000
                },
                headers: {
                  'Authorization' : 'Token '+localStorage.getItem('accessToken')
                }
              }).then((response) => {
                // console.log(this.data.start_date);
                // localStorage.setItem('filter', this.data);
                if (response.data.message.status == true) {

                  this.$isLoading(false)
                  this.tableData = response.data.message.data.statement

                  // console.log(this.tableData);
                  this.ServiceFee = 0
                  let summary = 0
                  for(var st in  response.data.message.data.statement){
                    //console.log(st)
                    if(response.data.message.data.statement[st].type=='PromptPay')
                      this.ServiceFee+=1;

                    summary= summary+response.data.message.data.statement[st].wasing_price_total
                  }
                  
                  this.$emit("UpdateSummary",  {'summary' : summary, 'ServiceFee' : this.ServiceFee})

                  // for (let idx in  response.data.message.data) {
                  //   console.log(idx)
                  // }
                  // console.log(this.tableData);
                  // console.log(response.data.message.data);
                } else {
                  this.$router.push('/login')
                }
              }).catch(error => {
                console.log(error)
                this.$router.push('/login')
              });
        }
        
      }
    },
   async mounted() {
       this.$isLoading(true)
           
      // eslint-disable-next-line no-undef
      apiService.check();


      // this.range[0] =  moment().format('YYYY-MM-DD'),
      // this.range[1] = new Date()
      console.log(this.range, 'datepiceker')

      this.range = [new Date(), new Date()];
      
      
      axios({
        method: 'post',
        url: JwService.getAPI()+'/api/method/justwash.OwnerApi.GetDepositStatements2',
        data: {
            start_date: moment().format('YYYY-MM-DD'),
            to_date: moment().format('YYYY-MM-DD'),
            limit: 100000000
        },
        headers: {
          'Authorization' : 'Token '+localStorage.getItem('accessToken')
        }
      }).then((response) => {
        if (response.data.message.status==true) {
           this.$isLoading(false)
          this.tableData = response.data.message.data.statement
          //this.$emit("UpdateSummary", response.data.message.data.summary)
          // console.log(this.tableData);
          this.ServiceFee = 0
          let summary = 0;
          for(var st in  response.data.message.data.statement){
            //console.log(st)
            if(response.data.message.data.statement[st].type=='PromptPay')
              this.ServiceFee+=1;

            summary= summary+response.data.message.data.statement[st].wasing_price_total



          }
          
          this.$emit("UpdateSummary",  {'summary' : summary, 'ServiceFee' : this.ServiceFee})

          // for (let idx in  response.data.message.data) {
          //   console.log(idx)
          // }
          // console.log(this.tableData);
          // console.log(response.data.message.data);
        } else {
          this.$router.push('/login')
        }
      }).catch(error => {
        console.log(error)
        this.$router.push('/login')
      });
    }
  }
</script>
<style>
</style>
